<template>
  <div class="content">
    <!-- <header>
      <i class="iconfont icon-home_location_icon_l" @click="returnBack"></i>
      <p @click="showpopup">{{timeValue}}</p>
      <van-icon
        name="arrow-down"
        @click="showpopup"
        :class="{pro:show||!show,round:show,round2:!show}"
      />
      <span>总分：</span>
      <span>{{score}}</span>
    </header>-->
    <h5-header :header-msg="headerMsg"></h5-header>
    <van-tabs
      v-model="active"
      swipeable
      background="#F5F5F5"
      title-active-color="#EC130C"
      title-inactive-color="#666"
      class="tabs"
      ref="tabs"
      :swipe-threshold='5'
      @change="changeType"
    >
      <van-tab :title="advance" class="tabsA" v-if='bol'>
        <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
        <!-- 缺省页 -->
        <Lack v-if="data0.length<=0"></Lack>
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="nullText"
          :immediate-check="false"
          :offset="200"
          @load="onLoad()"
          v-else
        >
          <div
            v-for="(item,index) in data0"
            :key="index"
            class="common"
          >
            <div>
              <span>订单佣金收入(待结算)</span>
              <span>+{{item.money}}</span>
            </div>
            <p>
              <span>订单号 {{item.orderSn}}</span>
              <span>{{item.time}}</span>
            </p>
          </div>
        </van-list>

        <!-- </van-pull-refresh> -->
      </van-tab>
      <van-tab :title="orderCount" class="tabsA">
        <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
        <!-- 缺省页 -->
        <Lack v-if="data1.length<=0"></Lack>
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="nullText"
          :immediate-check="false"
          :offset="200"
          @load="onLoad()"
          v-else
        >
          <div
            v-for="(item,index) in data1"
            :key="index"
            @click="goOrderInCludeDetail(item.orderId,item.name)"
            class="common"
          >
            <div>
              <span>{{item.name}}</span>
              <span>+{{item.money}}</span>
            </div>
            <p>
              <span>订单号 {{item.orderSn}}</span>
              <span>{{item.createTime}}</span>
            </p>
          </div>
        </van-list>

        <!-- </van-pull-refresh> -->
      </van-tab>
      <van-tab :title="rewardCount" class="tabsA tab_join" ref="tab_join">
        <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
        <!-- 缺省页 -->
        <Lack v-if="data2.length<=0"></Lack>
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="nullText"
          :immediate-check="false"
          @load="onLoad()"
          :offset="200"
          v-else
        >
          <div v-for="(item,index) in data2" :key="index" class="common">
            <div>
              <span>{{item.name}}</span>
              <span v-if="bol">+{{item.money}}</span>
              <span v-else style="color:#2DAE19">-{{item.money}}</span>
            </div>
            <p>
              <span>订单号 {{item.orderSn}}</span>
              <span>{{item.createTime}}</span>
            </p>
          </div>
        </van-list>

        <!-- </van-pull-refresh> -->
      </van-tab>
      <van-tab :title="purchaseCount" class="tabsA tab_join" ref="tab_join">
        <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
        <!-- 缺省页 -->
        <Lack v-if="data3.length<=0"></Lack>
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="nullText"
          :immediate-check="false"
          :offset="200"
          @load="onLoad()"
          v-else
        >
          <div
            v-for="(item,index) in data3"
            :key="index"
            class="common"
            @click="goCommisDetails(item)"
          >
            <div>
              <span>{{item.name}}</span>
              <span v-if="bol">+{{item.money}}</span>
              <span v-else style="color:#2DAE19">-{{item.money}}</span>
            </div>
            <p>
              <span v-show="!bol">订单号 {{item.orderSn}}</span>
              <span v-show="bol"></span>
              <span>{{item.createTime}}</span>
            </p>
          </div>
        </van-list>

        <!-- </van-pull-refresh> -->
      </van-tab>
      <van-tab :title="complaintCount" class="tabsA tab_join" ref="tab_join">
        <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
        <!-- 缺省页 -->
        <Lack v-if="data4.length<=0"></Lack>
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="nullText"
          :immediate-check="false"
          @load="onLoad()"
          :offset="200"
          v-else
        >
          <div
            v-for="(item,index) in data4"
            :key="index"
            @click="goComplaintDetail(item.orderId)"
            class="common"
          >
            <div>
              <span>{{item.name}}</span>
              <span style="color:#2DAE19" v-show="item.name.indexOf('撤销') == -1">-{{item.money}}</span>
              <span style="color:#EC130C" v-show="item.name.indexOf('撤销') != -1">+{{item.money}}</span>
              <!-- <span style="color:#EC130C" v-show="item.name == ''">+{{item.money}}</span> -->
            </div>
            <p>
              <span>订单号 {{item.orderSn}}</span>
              <span>{{item.createTime}}</span>
            </p>
          </div>
        </van-list>

        <!-- </van-pull-refresh> -->
      </van-tab>
    </van-tabs>
    <!-- <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :formatter="formatter"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>-->
  </div>
</template>

<script>
import {
  incomeList,
  purchaseList,
  getCfpExpectOrder
} from "@/api/picker/index";
import Lack from "@/components/lack/lack";
export default {
  components: {
    Lack
  },
  data() {
    return {
      show: false,
      currentDate: new Date(), //日期选择器选中的时间
      timeValue: "", //格式化后的时间
      score: "1231", //总分
      active: "0",
      headerMsg: {
        title: "收入明细",
        url: ""
      },
      page: 1, //分页
      pages: 1, //分页
      finished: false, //加载完成
      loading: false, //上拉加载
      isLoading: false, //下拉刷新
      nullText: "",
      orderCount: "", //订单收入/转入title
      rewardCount: "", //赏金收入/可提现title
      complaintCount: "", //罚款纪录/缺货扣除title
      purchaseCount: "", //自管档/采购金title
      advance: "预收", //预收
      data0: [], //预收data
      data1: [], //订单收入/转入data
      data2: [], //赏金收入/可提现data
      data3: [], //采购金/自管档data
      data4: [], //罚款纪录/缺货扣除data
      bol: true //是否是收入明细
    };
  },
  mounted() {
    // this.addScore = "加分(" + 2 + ")";
    // this.cutScore = "减分(" + 2 + ")";
    if (!this.$store.getters.token || this.$store.getters.token == "") {
      this.$store.commit("user/SET_token", this.GetQueryString("token"));
    }
    if (this.GetQueryString("source") == 1) {
      this.bol = false;
      this.headerMsg.title = "采购金明细";
      this.purchaseList("1"); //订单收入
      return;
    }
    this.purchaseList("3"); //采购金
    this.incomeList("1"); //订单收入
    this.getCfpExpectOrder('1');
    this.bol = true;
    this.headerMsg.title = "收入明细";
    // this.incomeList("2"); //赏金收入
    // this.incomeList("3"); //罚款纪录
  },
  methods: {
    showpopup: function() {
      if (!this.show) {
        this.show = true;
      } else {
        this.show = false;
      }
    },

    // 收入明细列表接口
    incomeList(types) {
      // console.log(this.$store.getters.token,'343434')
      if (types == 0) {
        return
      }
      this.nullText = "";
      let type = types == 4 ? "3" : types;
      let obj = {
        token: this.$store.getters.token || this.GetQueryString("token"),
        type: type, //1 订单收入  2赏金收入 3 罚款记录
        page: {
          way: "1", // 0:不分页 1:分页
          index: this.page.toString(), //请求页
          size: "10" //请求大小
        }
      };
      incomeList(obj).then(res => {
        //console.log(res);
        if (res.appStatus.errorCode == 0) {
          const list = res.content.list;
          if (list.length < 10) {
            // 最后一页不足10条的情况
            this.finished = true;
            setTimeout(() => {
              this.nullText = "没有更多了";
            }, 1000);
          }
          // this.orderCount = "佣金(" + res.content.orderCount + ")";
          // this.rewardCount = "赏金(" + res.content.rewardCount + ")";
          // this.complaintCount = "扣款记录(" + res.content.complaintCount + ")";
          this.orderCount = "佣金";
          this.rewardCount = "赏金";
          this.complaintCount = "扣款";
          if (this.page == 1) {
            this["data" + types ] = list;
          } else {
            this["data" + types] = [
              ...(this["data" + types ] || []),
              ...list
            ];
          }
          
        } else {
          this.finished = true;
          this.nullText = "没有更多了";
          this.loading = false;
          // this.orderCount = "佣金";
          // this.rewardCount = "赏金";
          // this.purchaseCount = "采购金";
          // this.complaintCount = "扣款";
          this.$toast(res.appStatus.message);
        }
        setTimeout(() => {
          this.loading = false;
          this.page += 1;
        }, 500);
      });
      // .finally(() => {

      // });
    },

    // 采购金明细列表接口
    purchaseList(type) {
      this.nullText = "";
      let obj = {
        token: this.$store.getters.token || this.GetQueryString("token"),
        type: type, //1 金额转入  2到可提现 3 缺货扣除 4到自管档
        page: {
          way: "1", // 0:不分页 1:分页
          index: this.pages.toString(), //请求页
          size: "10" //请求大小
        }
      };
      purchaseList(obj).then(res => {
        //console.log(res);
        if (res.appStatus.errorCode == 0) {
          const list = res.content.list;
          if (list.length < 10) {
            // 最后一页不足10条的情况
            this.finished = true;
            setTimeout(() => {
              this.nullText = "没有更多了";
            }, 1000);
          }
          console.log(this.data4)
          if (this.GetQueryString("source") == 1) {
            // this.orderCount = "转入(" + res.content.inCount + ")";
            // this.rewardCount = "可提现(" + res.content.finallyCount + ")";
            // this.purchaseCount = "自管档(" + res.content.hostCount + ")";
            // this.complaintCount = "缺货扣除(" + res.content.lackCount + ")";

            this.orderCount = "转入";
            this.rewardCount = "可提现";
            this.purchaseCount = "自管档";
            this.complaintCount = "缺货扣除";
          } else {
            // this.purchaseCount = "采购金(" + res.content.finallyCount + ")";
            this.purchaseCount = "采购金";
          }
          if (this.pages == 1) {
            if (this.GetQueryString("source") == 0) {
              if (type == 2) {
                this.data3 = list;
              } else {
                this.data2 = list;
              }
            } else {
              this["data" + (type == 3 ? 4 : type == 4 ? 3 : type)] = list;
            }
          } else {
            if (this.GetQueryString("source") == 0) {
              if (type == 2) {
                this.data3 = [...(this.data3 || []), ...list];
              } else {
                this.data2 = [...(this.data2 || []), ...list];
              }
            } else {
              this["data" + (type == 3 ? 4 : type == 4 ? 3 : type)] = [
                ...(this["data" + (type == 3 ? 4 : type == 4 ? 3 : type)] ||
                  []),
                ...list
              ];
            }
          }
          
        } else {
          this.finished = true;
          this.nullText = "没有更多了";
          this.loading = false;
          // this.orderCount = "转入";
          // this.rewardCount = "可提现";
          // this.purchaseCount = "自管档";
          // this.complaintCount = "缺货扣除";
          this.$toast(res.appStatus.message);
        }
        setTimeout(() => {
          this.loading = false;
          this.pages += 1;
        }, 500);
      });
      // .finally(() => {

      // });
    },

    // 收入明细列表接口
    getCfpExpectOrder(types) {
      // console.log(this.$store.getters.token,'343434')
      if (types!=1) {
        return
      }
      this.nullText = "";
      let type = types == 4 ? "3" : types;
      let obj = {
        token: this.$store.getters.token || this.GetQueryString("token"),
        // type: type, //1 订单收入  2赏金收入 3 罚款记录
        page: {
          way: "1", // 0:不分页 1:分页
          index: this.page.toString(), //请求页
          size: "10" //请求大小
        }
      };
      getCfpExpectOrder(obj).then(res => {
        //console.log(res);
        if (res.appStatus.errorCode == 0) {
          const list = res.content.list;
          if (this.page == 1) {
            this.data0 = list;
          } else {
            this.data0 = [...(this.data0 || []), ...list];
          }
          if (list.length < 10) {
            // 最后一页不足10条的情况
            this.finished = true;
            setTimeout(() => {
              this.nullText = "没有更多了";
            }, 1000);
          }
        } else {
          this.finished = true;
          this.nullText = "没有更多了";
          this.loading = false;
          this.$toast(res.appStatus.message);
        }
        setTimeout(() => {
          this.loading = false;
          this.page += 1;
        }, 500);
      });
    },

    onLoad() {
      this.toggleIncome();
    },
    // 订单收入详情跳转
    goOrderInCludeDetail(id, name) {
      if (this.GetQueryString("source") == 1 || name.indexOf("配送费") != -1) {
        return;
      }
      this.$router.push({
        path: "/orderIncludeDetail",
        query: {
          id
        }
      }); //跳转
    },

    // 扣款纪录详情跳转
    goComplaintDetail(id) {
      if (this.GetQueryString("source") == 1) {
        return;
      }
      this.$router.push({
        path: "/complaintHandDetails",
        query: {
          id,
          type: 1
        }
      }); //跳转
    },
    //采购金详情跳转
    goCommisDetails(item) {
      if (this.GetQueryString("source") == 1) {
        return;
      }
      this.$router.push({
        path: "/commisDetails",
        query: {
          item
        }
      }); //跳转
    },
    //tabs切换事件
    changeType() {
      this.page = 1;
      this.pages = 1;
      this.finished = false;
      this.loading = true;
      for (let i = 0; i < 5; i++) {
        this["data" + i] = [];
      }
      this.toggleIncome();
    },

    //首次加载数据
    toggleIncome() {
      if (this.GetQueryString("source") == 1) {
        switch (this.active) {
          case 0:
            this.purchaseList(1);
            break;
          case 1:
            this.purchaseList(2);
            break;
          case 2:
            this.purchaseList(4);
            break;
          case 3:
            this.purchaseList(3);
            break;
          default:
            break;
        }
        return;
      }
      console.log(this.active)
      if (this.active == 3) {
        this.purchaseList(2); //采购金
        return;
      }
      // console.log(this.active)
      this.incomeList(this.active);
      this.getCfpExpectOrder(this.active+1);
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  .tabs {
    margin-top: 0px;
    /deep/.van-tabs__wrap{
      position: fixed;
      top: 44px;
      width: 100%;
    }
    /deep/.van-tabs__content{
      margin-top: 44px;
    }
    /deep/.van-tab--active {
      font-weight: bold;
    }
   
    /deep/.van-pull-refresh {
      overflow: initial;
    }
    .clicks {
      color: #999 !important;
    }
    .common {
      width: auto;
      min-height: 50px;
      display: flex;
      flex-flow: column;
      justify-content: space-around;
      padding: 15px 12px;
      border-bottom: 1px solid #f0f0f0;
      div {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: left;
        span:first-child {
          color: #1d1d1d;
          font-size: 16px;
          // letter-spacing: 2px;
          font-weight: bold;
        }
        span:nth-child(2) {
          display: block;
          color: #ec130c;
          font-size: 18px;
        }
        span:last-child {
          display: block;
          color: #ec130c;
          font-size: 18px;
        }
      }
      p {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0;
        span:first-child {
          color: #666;
          font-size: 14px;
          margin-top: 5.5px;
        }

        span:last-child {
          display: block;
          color: #666;
          font-size: 14px;
          margin-top: 5.5px;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>

